import React, { useEffect, useState } from "react";

import Userimg from "../../../img/userimg.svg";
import { Card, Skeleton, Tabs } from "antd";
import { getSingleGroup } from "../../../api/AdminRequest";
import BidList from "./BidList";
import BuyerList from "./BuyerList";
const GroupSingleView = ({ id }) => {
  const { TabPane } = Tabs;

  const [groupDetails, setGroupDetails] = useState(null);
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    const singleBuyerCall = async () => {
      try {
        const { data } = await getSingleGroup(id);
        console.log(data, "data");

        if (data.success) {
          setLoader(false);
          setGroupDetails(data.singleGroup);
        } else {
          setLoader(false);
        }
      } catch (error) {
        setLoader(false);

        console.log(error);
      }
    };
    singleBuyerCall();
  }, [id]);

  return (
    <div className=" p-4 lg:p-6 md:p-5">
      <div className="lg:stick top-0 pb-3 z-10  bg-white">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 mt-7 mb-4">
          {!groupDetails ? (
            <Skeleton
              avatar
              paragraph={{
                rows: 3,
              }}
            />
          ) : (
            <div className="flex items-center gap-4 w-full md:w-auto">
              <img
                src={Userimg}
                alt="Metasoft IT Pvt ltd"
                className="w-20 h-20 rounded-full"
              />
              <div className="text-center md:text-left">
                <h2 className="text-[20px] md:text-[25px] text-[#313131] font-semibold">
                  {groupDetails.name}
                </h2>
                <p className="text-[14px] md:text-[17px] font-normal text-[#4A4A4C]">
                  {groupDetails?.members?.length}
                </p>
                <div className="flex flex-col md:flex-row items-center gap-2">
                  <span className="text-[14px] md:text-[17px] font-normal text-[#878787]">
                    {groupDetails.domain}
                  </span>
                  <p className="text-[14px] md:text-[17px] font-medium text-[#1955EB] underline">
                    Change
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="pt-[0px] space-y-10">
        <Card style={{ marginTop: "24px" }}>
          <Tabs defaultActiveKey="1">
            <TabPane tab="Buyer List" key="1">
              {!loader && <BuyerList groupID={groupDetails?._id} />}
            </TabPane>
            <TabPane tab="Bid List" key="2">
              <BidList groupID={groupDetails?._id} />
            </TabPane>
          </Tabs>
        </Card>
      </div>
    </div>
  );
};

export default GroupSingleView;
